import * as Sentry from "@sentry/browser";
import "airbnb-js-shims";
import React from "react";
import "react-dates/initialize";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./components/App";
import configureStore from "./redux/store";
// import App from "./components/Stealth";
import * as serviceWorker from "./serviceWorker";

Sentry.init({
  dsn:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_SENTRY_DSN
      : ""
});

const { store, persistor } = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
